module.exports = __webpack_public_path__ + "img/drumstick-bite.85e34b01.svg";